import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { useUIStore } from '../stores/uiStore';

export default function Layout() {
    const { sidebarOpen } = useUIStore();

    return (
        <div className="flex h-screen overflow-hidden bg-dark-950">
            {/* Sidebar */}
            <Sidebar />

            {/* Main content area */}
            <div
                className={`flex flex-col flex-1 overflow-hidden transition-all duration-300 ${sidebarOpen ? 'md:ml-72' : 'ml-0'
                    }`}
            >
                {/* Navbar */}
                <Navbar />

                {/* Page content */}
                <main className="flex-1 overflow-auto">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
